import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.deviceType,
  baseAttrName: 'options',
  baseAttrField: 'options',
  field: 'firmwareUpgrade/removeStaleUpgradingDevices',
  creatable: false,
  editable: true,
  editOptions: {
    containerProps: {
      fillCell: true
    }
  },
  displayName: 'Firmware Upgrade Remove Stale Upgrading Devices',
  valueType: 'boolean'
});